import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { normalizeSession } from '../../utils/authSession';
export default function PrivateRoute({ children }) {
  const auth = useSelector((state) => state.authSlice);
  const location = useLocation();
  return normalizeSession(auth).isLoggedIn ? children : <Navigate to="/auth/login" state={{ from: location.pathname }} replace />;
}
